<fullscreen-page>
  <content-column>
    <div class="d-flex flex-column flex-fill w-100 mx-auto overflow-auto" slot="content">
      <div class="d-flex flex-column np-header">
        <div class="p-2 h2" style="color: var(--dx-color-primary);">
          {{ 'Katalog-Container' | translate }}
        </div>
        <div class="d-flex flex-row p-2" style="align-items:center;">
          <dx-button (onClick)="openContainerEditPopup()"
                     stylingMode="outlined"
                     text="{{ 'Neuen Katalog-Container' | translate }}"
                     type="default"/>
          <dx-text-box [(value)]="containerSearchText" mode="search"/>
        </div>
      </div>
      <div class="d-flex flex-row flex-grow-1">
        <dx-card-view (onCardClick)="onContainerClicked($event)"
                      [allowColumnReordering]="true"
                      [dataSource]="containers"
                      [hoverStateEnabled]="true"
                      cardFooterTemplate="footerTemplate"
                      cardsPerRow="auto"
                      class="h-100 flex-grow-1"
                      keyExpr="id"
                      noDataTemplate="noDataTextTemplate" >
          <div *dxTemplate="let catalog of 'noDataTextTemplate'">
            {{ 'Ups, noch nix da?' | translate }}
            <dx-button (onClick)="openContainerEditPopup()"
                       stylingMode="text"
                       text="{{ 'Hier geht es los' | translate }}"
                       type="default"/>
          </div>
          <dxo-card-view-search-panel [(text)]="containerSearchText" [visible]="false"/>
          <dxo-card-view-header-panel [visible]="false"/>
          <dxo-card-view-card-cover [altExpr]="altExpr" [imageExpr]="imageExpr"/>
          <dxo-card-view-selection mode="single"/>

          <dxo-toolbar>
            <dxi-item location="before" name="searchPanel"></dxi-item>
          </dxo-toolbar>

          <dxi-card-view-column [allowSearch]="true"
                                caption="{{ 'Name' | translate }}"
                                dataField="name"/>
          <dxi-card-view-column [allowSearch]="false"
                                [calculateFieldValue]="calculateCatalogCount"
                                caption="{{ 'Kataloge' | translate }}"/>
          <dxi-card-view-column [allowSearch]="false"
                                caption="{{ 'Produkte' | translate }}"
                                dataField="productCount"/>
          <dxi-card-view-column [allowSearch]="true"
                                caption="{{ 'Notiz' | translate }}"
                                dataField="note"/>

          <div *dxTemplate="let params of 'footerTemplate'">
            <div class="d-flex gap-2 card-footer">
              <dx-button
                (onClick)="goToDetails(params.card?.data)"
                icon="chevrondoubleright"
                stylingMode="contained"
                text="{{ 'Details' | translate }}"
                type="default">
              </dx-button>
            </div>
          </div>
        </dx-card-view>

        <np-inspect-panel
          (containerSaved)="onContainerSaved($event)"
          [container]="selectedContainer"
          context="containerDetails">
        </np-inspect-panel>

      </div>
    </div>
  </content-column>
</fullscreen-page>

<np-container-edit
  (onSaved)="onContainerSaved($event)"
  [(visible)]="containerEditVisible"
  [container]="editedContainer"
  [editMode]="false">
</np-container-edit>
